import { PnlBreakdown } from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { useTranslation } from "react-i18next";
import {
  getSummaryMetrics,
  SummaryMetricInput,
} from "reports/utils/metricUtils";
import CardWrapper from "../CardWrapperStyles";
import { TFunction } from "i18next";
import { brightBlue } from "reports/constants/colors";
import { Bar, LabelList } from "recharts";
import { RightBarLabel } from "../RechartHelpers/RechartBarLabels";
import styled from "styled-components/macro";
import GenericComposedChart, {
  renderCustomBar,
} from "./BarCharts/GenericComposedChart";
import {
  CHART_HEIGHT,
  CHART_WIDTH,
} from "../BespokeReports/bespokeReportUtils";
import useEosData from "reports/store/useEosData";

const MetricPerProcessChartStyles = styled.div`
  display: flex;
  justify-content: center;
`;

export default function MetricPerProcessChart({
  summaryMetricInput,
  width = CHART_WIDTH,
  height = CHART_HEIGHT,
  color = brightBlue,
}: {
  summaryMetricInput: SummaryMetricInput;
  width?: number;
  height?: number;
  color?: string;
}) {
  const { t } = useTranslation("EOSReport");
  const { pnlBreakdownsByProcess } = useEosData();

  const chartData = getChartData({
    t,
    pnlBreakdownsByProcess,
    summaryMetricInput,
  });
  const title = summaryMetricInput.title ?? summaryMetricInput.name ?? "";

  const customBars = (
    <Bar
      dataKey="metric"
      name={title}
      fill={color}
      isAnimationActive={false}
      shape={renderCustomBar(height)}
    >
      <LabelList dataKey={"stringValue"} content={RightBarLabel({})} />
    </Bar>
  );

  return (
    <CardWrapper>
      <div className="header">{t(title)}</div>
      <MetricPerProcessChartStyles>
        <GenericComposedChart
          data={chartData}
          vertical={true}
          bars={[]}
          {...{ customBars, width, height }}
          xLabel={t(title)}
          yLabel={""}
          xKey={"metric"}
          yKey={"processName"}
        />
      </MetricPerProcessChartStyles>
    </CardWrapper>
  );
}

function getChartData({
  t,
  summaryMetricInput,
  pnlBreakdownsByProcess,
}: {
  t: TFunction;
  summaryMetricInput: SummaryMetricInput;
  pnlBreakdownsByProcess: PnlBreakdown[];
}) {
  return (
    pnlBreakdownsByProcess
      .map(pnlBreakdown => {
        const { numericValue, unit } = getSummaryMetrics({
          metrics: [summaryMetricInput],
          pnlBreakdown,
          t,
        })[0];

        const processName = pnlBreakdown.processNames[0];
        return {
          processName,
          metric: numericValue ?? 0,
          numericValue,
          stringValue:
            numericValue === null ? "--" : `${numericValue}${unit ?? ""}`,
        };
      })
      // Sort by numbers, putting null values at the end
      .sort((a, b) =>
        a.numericValue === b.numericValue
          ? 0
          : a.numericValue === null
            ? 1
            : b.numericValue === null
              ? -1
              : b.numericValue - a.numericValue
      )
  );
}
